import React from 'react';

const CloseInput: React.FC = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.5">
                <path
                    d="M5.17163 10.8281L10.8285 5.17127"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M5.17822 5.17969L10.8351 10.8365"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};

export default CloseInput;